RivalIQ.module('export.data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const ReportSchedules = RivalIQ.data.CacheLayer.extend({
        name: 'Report Schedules',
        cacheKeys: [
            'landscapeId'
        ],

        loadData: function () {
            const schedules = new RivalIQ.export.collections.ReportSchedules();
            const deferred = new $.Deferred();
            schedules.fetch()
                .done(_.partial(deferred.resolve, schedules))
                .fail(deferred.reject);

            return deferred;
        },

        fetch: function () {
            const me = this;
            return me.getOrLoad({
                landscapeId: RivalIQ.state.view.get('landscapeId')
            });
        },

        add: function (model) {
            const me = this;
            return me.addModel(model, {
                landscapeId: RivalIQ.state.view.get('landscapeId')
            });
        }
    });

    data.reportSchedules = new ReportSchedules();
});
